import script from "./MoreBtnOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreBtnOptions.vue?vue&type=script&setup=true&lang=js"

import "./MoreBtnOptions.vue?vue&type=style&index=0&id=c8634392&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8634392"]])

export default __exports__